@if (editor) {
  <div class="NgxEditor__Wrapper" [ngClass]="class" >
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [disabled]="disabled" > </ngx-editor-menu>
    <ngx-editor  [editor]="editor" [placeholder]="''" [(ngModel)]="htmlContent" [disabled]="disabled" (focusOut)="onInputBlur()" (ngModelChange)="valueChange()" ></ngx-editor>
  </div>
}